import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        title: 'Dashboard - DataRecs Console'        
      },
      {
        path: 'connections',
        loadChildren: () => import('./features/connections/connections.routes').then(m => m.CONNECTIONS_ROUTES)
      },
      {
        path: 'jobs',
        loadChildren: () => import('./features/jobs/jobs.routes').then(m => m.JOBS_ROUTES)
      },
      {
        path: 'job-groups',
        loadChildren: () => import('./features/jobs/job-groups.routes').then(m => m.JOB_GROUPS_ROUTES)
      },
      {
        path: 'keys',
        loadChildren: () => import('./features/keys/keys.routes').then(m => m.KEYS_ROUTES)
      },
      {
        path: 'data-storage',
        loadChildren: () => import('./features/data-storage/data-storage.routes').then(m => m.DATA_STORAGE_ROUTES)
      },
      {
        path: 'workspaces',
        loadChildren: () => import('./features/workspaces/workspaces.routes').then(m => m.WORKSPACES_ROUTES)
      },
      {
        path: 'connectors',
        loadChildren: () => import('./features/connectors/connectors.routes').then(m => m.CONNECTORS_ROUTES)
      },
      {
        path: 'api-keys',
        loadChildren: () => import('./features/api-keys/api-keys.routes').then(m => m.API_KEYS_ROUTES)
      },
      {
        path: 'webhooks',
        loadChildren: () => import('./features/webhooks/webhooks.routes').then(m => m.WEBHOOKS_ROUTES)
      },
      {
        path: 'support',
        loadChildren: () => import('./features/support/support.routes').then(m => m.SUPPORT_ROUTES)
      },
      {
        path: 'permissions',
        loadChildren: () => import('./features/permissions/permissions.routes').then(m => m.PERMISSIONS_ROUTES)
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.routes').then(m => m.ROLES_ROUTES)
      },
      {
        path: 'results',
        loadChildren: () => import('./features/results/results.routes').then(m => m.RESULTS_ROUTES)
      },
      {
        path: 'audit',
        loadChildren: () => import('./features/audit/audit.routes').then(m => m.AUDIT_ROUTES)
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadChildren: () => import('./features/admin/admin.routes').then(m => m.ADMIN_ROUTES)
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then(m => m.PROFILE_ROUTES)
      }
    ]
  },
  {
    // Public tenant picker — the landing page for unauthenticated users.
    // Collects the Tenant_Slug so the request can be routed to the tenant's Cell
    // (one Cell hosts many tenants; one tenant lives in exactly one Cell). This is the
    // cell-routing identity ABOVE a tenant — NOT an in-tenant workspace (RBAC sub-grouping).
    // The edge router sends browser navigations with no routing identifier here (R5.6).
    // No auth guard — this is the pre-auth step.
    path: 'tenant',
    loadComponent: () => import('./layouts/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/tenant-picker/tenant-picker.component').then(
            m => m.TenantPickerComponent,
          ),
        title: 'Sign In — DataRecs',
      },
    ],
  },
  {
    // Legacy alias: the old pre-auth route was `/workspace`. Redirect to `/tenant`
    // so existing links / edge-router seams keep working.
    path: 'workspace',
    redirectTo: 'tenant',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
    children: [
      // {
      //   path: 'login-callback',
      //   loadComponent: () => import('./features/auth/login-callback/login-callback.component').then(m => m.LoginCallbackComponent)
      // },
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        // Branded failure page for a broken auth callback / free-trial sign-up (DRCS-411).
        // core-api's workos/callback redirects here on failure (/auth/error?ref=<id>) instead
        // of rendering raw JSON into a top-level navigation. Only ?ref=<id> is sent — a
        // URL-safe support reference that keys the server-side failure detail (pino + audit).
        path: 'error',
        loadComponent: () => import('./features/auth/sign-up-error/sign-up-error.component').then(m => m.SignUpErrorComponent),
        title: 'Sign-up error — DataRecs',
      },
      {
        path: 'device',
        loadComponent: () => import('./features/auth/device/device-verify.component')
      },
    ]
  },
  {
    path: 'auth/demo-sso',
    loadComponent: () => import('./features/auth/demo-sso/demo-sso.component').then(m => m.DemoSsoComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
